import { render, staticRenderFns } from "./HeroIcons.vue?vue&type=template&id=5d194f10&"
import script from "./HeroIcons.vue?vue&type=script&lang=js&"
export * from "./HeroIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports